import { videoModel } from "./defaults";

export const klingO1 = videoModel("kling-o1", "Kling O1 (Omni)", { start: 1, end: 1 }, {
  firstLast: "kling-video/omni/first-last-frame",
});
